import { AchievementFormState } from '@app/interface/ngrxInterfaces/achievement-form.state';
import { createReducer, on } from '@ngrx/store';
import {
  getAchievementForm,
  isCreating,
  isFormCompleted,
  isntCreating,
  isntFormCompleted,
  saveTitle,
  taskCompleted,
} from './achievement-form.actions';

const initialState: AchievementFormState = {
  getForm: false,
  isFormCompleted: false,
  isNewAchievement: false,
  titleAchievement: '',
};

export const achievementFormReducer = createReducer(
  initialState,
  on(getAchievementForm, state => ({
    ...state,
    getForm: true,
  })),
  on(taskCompleted, state => ({
    ...state,
    getForm: false,
  })),
  on(isFormCompleted, state => ({
    ...state,
    isFormCompleted: true,
  })),
  on(isntFormCompleted, state => ({
    ...state,
    isFormCompleted: false,
  })), //
  on(isCreating, state => ({
    ...state,
    isNewAchievement: true,
  })),
  on(isntCreating, state => ({
    ...state,
    isNewAchievement: false,
  })),
  on(saveTitle, (state, { titleForm }) => ({
    ...state,
    titleAchievement: titleForm,
  }))
);
